import { isMobile } from 'mobile-device-detect'
import { onMounted, onBeforeUnmount, ref } from 'vue'

export function useMobile() {
	const isKeyboardOpened = ref(false)

	onMounted(() => {
		if (isMobile) {
			window.visualViewport.addEventListener('resize', updateViewport)
		}
	})

	onBeforeUnmount(() => {
		if (isMobile) {
			window.visualViewport.removeEventListener('resize', updateViewport)
		}
	})

	const updateViewport = () => {
		if (window && window.visualViewport) {
			isKeyboardOpened.value = window.innerHeight > window.visualViewport.height
		}
	}

	return { isKeyboardOpened, isMobile }
}
